var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12722 9.83102L13.6473 16.7674C13.8609 17.0353 14.0605 17.288 14.4032 17.3834C14.5442 17.4225 14.6982 17.4225 15.0051 17.4225C15.3087 17.4225 15.4606 17.4225 15.5766 17.3628C15.8922 17.2023 15.8727 16.8639 15.8727 16.5549V13.5497M15.8727 13.5497L11.025 7.40284C10.7051 6.99724 10.5435 6.79444 10.3201 6.68599C10.0967 6.57754 9.83855 6.57754 9.32124 6.57754H8.1283M15.8727 13.5497V6.57754M8.1283 6.57754H6.57748M8.1283 6.57754V17.4225M6.57748 17.4225H9.83096M15.8727 6.57754H14.1689M15.8727 6.57754H17.4224M1.69727 12C1.69727 7.14364 1.69727 4.71438 3.20579 3.20586C4.71432 1.69733 7.1425 1.69733 11.9999 1.69733C16.8563 1.69733 19.2856 1.69733 20.7941 3.20586C22.3026 4.71438 22.3026 7.14256 22.3026 12C22.3026 16.8564 22.3026 19.2856 20.7941 20.7941C19.2856 22.3027 16.8574 22.3027 11.9999 22.3027C7.14358 22.3027 4.71432 22.3027 3.20579 20.7941C1.69727 19.2856 1.69727 16.8574 1.69727 12Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotion);
export default __webpack_public_path__ + "static/media/notion.9d02f05708e2f542c05d7da217bb4752.svg";
export { ForwardRef as ReactComponent };